import {
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Hidden,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined'
import { Skeleton } from '@material-ui/lab'
import React, { Fragment, useContext, useEffect, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import WhatsAppIcon from '../assets/icons/whatsapp.png'
import { Breadcrumb } from '../components/Breadcrumb'
import { CallToAction } from '../components/CalltoAction'
import Categorys from '../components/Categorys'
import { AlertDialog } from '../components/Feedback'
import { Footer } from '../components/Footer'
import { Header } from '../components/Header'
import { CustomSelect, NumberButtonsInput } from '../components/Inputs'
import VitrineProdutos from '../components/ListProducts/ListProducts'
import ProductCarousel from '../components/Media/ProductCarousel'
import ShopContext from '../contexts/Shop'
import Products from '../data/Products'
import getCleanCategorys from '../utils/getCleanCategorys'

import { debounce } from 'lodash'
import GA4 from '../services/GA4/ga4'
import MetaTags from '../utils/MetaTags'
const ProductData = new Products()
const ProductOne = new Products()

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 9,
    color: '#fff',
  },
  secondary: {
    color: theme.palette.secondary.main,
  },
  title: {
    lineHeight: 0.9,
  },
  sutitle: {
    color: theme.palette.text.secondary,
    fontSize: '1.4rem',
    lineHeight: 1.5,
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },
  label: {
    fontSize: '1.6rem',
  },
  subLabel: {
    fontSize: '1.2rem',
  },
  money: {
    fontSize: '3rem',
    marginLeft: 3,
    marginRight: 3,
    lineHeight: 1.1,
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.8rem',
    },
  },
  sub: {
    fontSize: '1.2rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  sob: {
    fontSize: '1.2rem',
    verticalAlign: 'top',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  discount: {
    fontSize: '1rem',
    textDecoration: 'line-through',
    marginBottom: -8,
  },
  borderRight: {
    borderRight: '2px solid #999999',
    paddingRight: '35px !important',
  },
  borderLeft: {
    borderLeft: '2px solid #999999',
    paddingLeft: '35px !important',
  },
  divider: {
    width: 2,
    backgroundColor: '#999999',
    height: '70%',
    marginLeft: 7,
  },
  gridCallToAction: {
    marginTop: theme.spacing(7),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  marginTop: {
    marginTop: theme.spacing(7),
  },
  marginBottom: {
    marginBottom: theme.spacing(7),
  },
  button: {
    backgroundColor: theme.palette.success.main,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: 7,
    paddingRight: 7,
    color: theme.palette.success.contrastText,
    borderRadius: 21,
    height: 74.8,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.success.contrastText,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 3),
    },
  },
  textButton: {
    fontSize: '2.1rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.7rem',
      lineHeight: 1,
    },
  },
  tag: {
    display: 'inline',
    textTransform: 'uppercase',
    padding: '1px 8px',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: theme.spacing(1),
    color: '#FFF',
    borderRadius: theme.spacing(1),
    fontSize: '1.4rem',
  },
  tagSobEncomenda: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFF',
    textAlign: 'center',
    fontSize: '20px',
    borderRadius: '10px',
  },
  estoque: {
    fontSize: '1.6rem',
    marginBottom: 0,
  },
}))

const Product = ({ cartData, ...props }) => {
  const shop = useContext(ShopContext)
  let itens = []
  if (shop?.categorys?.length > 0) {
    itens = getCleanCategorys(shop?.categorys)
  }

  const classes = useStyles(props)
  const theme = useTheme()
  //const mobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [product, setProduct] = useState(null)
  const [breadcrumbItens, setBreadcrumbItens] = useState(null)
  const [qtd, setQtd] = useState(500)
  const [valorUnitario, setValorUnitario] = useState(null)
  const [valorDesconto, setValorDesconto] = useState(null)
  const [valorDe, setValorDe] = useState(null)
  const [valorTotal, setValorTotal] = useState(null)
  const [gravacao, setGravacao] = useState(null)
  const [options, setOptions] = useState(null)
  const [images, setImages] = useState(null)
  const [itensCheckbox, setItensCheckbox] = useState([])
  const [openDialog, setOpenDialog] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingPage, setLoadingPage] = useState(false)
  //const [vitrineParams, setVitrineParams] = useState(null);
  const [atributos, setAtributos] = useState(null)
  const [variacoes, setVariacoes] = useState(null)
  const [skuAtual, setSkuAtual] = useState(null)
  const [skuUpdate, setSkuUpdate] = useState(false)

  const history = useHistory()

  useEffect(() => {
    async function callProduct(objProd) {
      try {
        setLoadingPage(true)
        await objProd.show(props.match.params.id, shop.id, props.match.params.sku)
        const prod = objProd.product
        const categoriaSlug = prod?.categoria_slug
        const subcategoriaSlug = prod?.subcategoria_slug
        if (props.match.params.subcategoria && subcategoriaSlug !== props.match.params.subcategoria) {
          history.push('/404')
        }
        setProduct(prod)
        setQtd(prod.quantidade_padrao)

        let breadcrumb = [
          { link: '/', text: 'Início' },
          { link: '/', text: 'Categorias' },
          {
            link: `/categoria/${categoriaSlug}`,
            text: prod.categoria,
          },
          {
            link: `/categoria/${categoriaSlug}/${subcategoriaSlug}`,
            text: prod.subcategoria,
          },
        ]

        setBreadcrumbItens(breadcrumb)

        const opts = []
        prod.gravacoes.forEach((gravacao) => {
          opts.push({ text: gravacao.tipo, value: gravacao.id })
        })

        setOptions(opts)
        setGravacao(opts[0].value)

        updateSkuInUrl(prod?.variacao?.sku)
        setSkuAtual(prod?.variacao)
        setVariacoes(prod?.variacoes)
        setAtributos(prod?.atributos)

        const imgs = []

        prod.images.forEach((img, index) => {
          imgs.push({ title: `${prod.nome} (${prod?.variacao?.sku})`, url: img })
        })

        setImages(imgs)

        //_refreshItensCheckbox(prod.tabela_preco)

        setLoadingPage(false)

        /* setVitrineParams({
          id: prod.id,
          nome: prod.nome,
          categoria: prod.categoria,
          subcategoria: prod.subcategoria,
        }); */
      } catch (error) {
        console.log('error', error)
        history.push('/404')
      }
    }

    callProduct(ProductOne)
  }, [props.match.params.id, skuUpdate])

  useEffect(() => {
    const loadProduct = (data) => {
      let prod = data.product

      prod.valor_unitario_slipt = parseFloat(prod.valor_unitario)
        .toLocaleString('pt-br', { minimumFractionDigits: 2 })
        .split(',')
        .slice(0)
      prod.valor_total_slipt = parseFloat(prod.valor_total)
        .toLocaleString('pt-br', { minimumFractionDigits: 2 })
        .split(',')
        .slice(0)
      prod.valor_de_slipt = parseFloat(prod.valor_sem_desconto)
        .toLocaleString('pt-br', { minimumFractionDigits: 2 })
        .split(',')
        .slice(0)

      setValorUnitario(prod.valor_unitario_slipt)
      setValorDe(prod.valor_de_slipt)
      setValorTotal(prod.valor_total_slipt)
      setProduct(prod)
    }

    ProductOne.subscribe(loadProduct)

    return function cleanup() {
      ProductOne.unsubscribe(loadProduct)
    }
  }, [])

  useEffect(() => {
    if (product) {
      GA4.viewProduct(product)
    }
  }, [product])

  const addToCart = async () => {
    await cartData.addCart(shop.id, product.id, qtd, gravacao, skuAtual)
    GA4.addToCart(product)
    setOpenDialog(true)
  }

  function _refreshItensCheckbox(tabela_preco) {
    const ofertas = ProductOne.product.oferta
    const itensQty = []
    /* itensQty.push({ qty : 50, price: parseFloat(tabela_preco.qtd_50 ).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 50)});
      itensQty.push({ qty : 100, price: parseFloat(tabela_preco.qtd_100).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 100) });
      itensQty.push({ qty : 200, price: parseFloat(tabela_preco.qtd_200).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 200) });
      itensQty.push({ qty : 300, price: parseFloat(tabela_preco.qtd_300).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 300) });
      itensQty.push({ qty : 500, price: parseFloat(tabela_preco.qtd_500).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 500) });
      itensQty.push({ qty : 1000, price: parseFloat(tabela_preco.qtd_1000).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 1000) });
      itensQty.push({ qty : 2000, price: parseFloat(tabela_preco.qtd_2000).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 2000) });
      itensQty.push({ qty : 3000, price: parseFloat(tabela_preco.qtd_3000).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 3000) });
      itensQty.push({ qty : 5000, price: parseFloat(tabela_preco.qtd_3000).toLocaleString('pt-br', {minimumFractionDigits: 2}), offer: getDesconto(ofertas, 5000) }); */

    itensQty.push({
      qty: 50,
      price: tabela_preco.qtd_50,
      offer: ProductOne.getDesconto(ofertas, 50),
    })
    itensQty.push({
      qty: 100,
      price: tabela_preco.qtd_100,
      offer: ProductOne.getDesconto(ofertas, 100),
    })
    itensQty.push({
      qty: 200,
      price: tabela_preco.qtd_200,
      offer: ProductOne.getDesconto(ofertas, 200),
    })
    itensQty.push({
      qty: 300,
      price: tabela_preco.qtd_300,
      offer: ProductOne.getDesconto(ofertas, 300),
    })
    itensQty.push({
      qty: 500,
      price: tabela_preco.qtd_500,
      offer: ProductOne.getDesconto(ofertas, 500),
    })
    itensQty.push({
      qty: 1000,
      price: tabela_preco.qtd_1000,
      offer: ProductOne.getDesconto(ofertas, 1000),
    })
    itensQty.push({
      qty: 2000,
      price: tabela_preco.qtd_2000,
      offer: ProductOne.getDesconto(ofertas, 2000),
    })
    itensQty.push({
      qty: 3000,
      price: tabela_preco.qtd_3000,
      offer: ProductOne.getDesconto(ofertas, 3000),
    })
    itensQty.push({
      qty: 5000,
      price: tabela_preco.qtd_3000,
      offer: ProductOne.getDesconto(ofertas, 5000),
    })

    const itensFilter = itensQty.filter((item) => {
      return item.qty >= parseInt(ProductOne.product.quantidade_minima)
    })

    setItensCheckbox(itensFilter.slice(0, 7))
  }

  const _handleQtd = async (value) => {
    setLoading(true)
    setQtd(value)
    await ProductOne.updateValues(product.id, shop.id, parseFloat(value), gravacao)
    //_refreshItensCheckbox(ProductOne.tabela_preco)
    setLoading(false)
  }

  const debouncedHandleQtd = debounce(_handleQtd, 500)

  const _handleGravacao = async (e) => {
    setLoading(true)
    setGravacao(e.target.value)
    await ProductOne.updateValues(product.id, shop.id, qtd, e.target.value)
    //_refreshItensCheckbox(ProductOne.tabela_preco)
    setLoading(false)
  }

  const vitrineData = useMemo(
    () => ({
      backgroundCardsContainer: '#F0F0F0',
      paddingCardsContainer: 21,
      title: `Mais ${product?.categoria || ''}`,
      titleStyle: { textTransform: 'initial', marginBottom: 14 },
      sm: 4,
      numItens: 6,
      offSet: 0,
      category: product?.categoria || null,
      except: [product?.id],
      dataProducts: ProductData,
      name: `Vitrine Página Produto ${product?.nome || ''}`,
    }),
    [product, ProductData]
  )

  function updateSkuInUrl(newSku) {
    const newPath = props.match.params.sku
      ? window.location.pathname.replace(`/${props.match.params.sku}`, `/${newSku}`)
      : `${window.location.pathname}/${newSku}`

    history.replace(newPath)
  }

  const handleAtributosChange = (attribute, valueAttribute) => {
    if (skuAtual && variacoes) {
      var attributesSku = skuAtual?.atributos

      const attrSku = attributesSku.filter((attr) => {
        return attr.atributo.toLowerCase() !== attribute.toLowerCase()
      })

      attributesSku = [...attrSku, { atributo: attribute, valor: valueAttribute }]

      const skuSelect = variacoes.filter((sku) => {
        return attributesSku.every((attrA) => {
          return sku.atributos.some((attrB) => {
            return (
              attrB.atributo.toLowerCase() === attrA.atributo.toLowerCase() &&
              attrB.valor.toLowerCase() === attrA.valor.toLowerCase()
            )
          })
        })
      })

      if (skuSelect.length > 0) {
        updateSkuInUrl(skuSelect[0]?.sku)
        setSkuUpdate((prev) => !prev)
      } else {
        const skuSelectAvailable = variacoes.filter((sku) => {
          const anyAttr = sku.atributos.filter((attr) => attr.valor === valueAttribute)
          return anyAttr.length > 0
        })
        updateSkuInUrl(skuSelectAvailable[0]?.sku)
        setSkuUpdate((prev) => !prev)
      }
    }
  }

  return (
    <Fragment>
      {product && (
        <MetaTags
          meta_title={product?.meta_title}
          canonical_url={product?.canonical_url}
          meta_description={product?.meta_description}
          nome_loja={shop?.nome}
          image={product?.images?.[0]}
          type="product"
        />
      )}
      <Backdrop open={loadingPage} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Header shop={shop} dataCart={cartData} />
      <Breadcrumb itens={breadcrumbItens} />
      <Container>
        <Grid container spacing={5} alignItems="flex-start">
          <Grid item xs={12} sm={7}>
            {images ? <ProductCarousel images={images} /> : <Skeleton variant="rect" width="100%" height={500} />}
          </Grid>

          <Grid container item xs={12} sm={5} spacing={3} justify="space-between" alignContent="center">
            <Grid item xs={12}>
              <Typography variant="h4" component="h3" className={classes.title}>
                {product ? product.nome : <Skeleton animation="wave" />}
              </Typography>
              {product ? (
                <Grid item xs={12} md={12} sm={12} style={{ display: 'flex', alignItems: 'baseline' }}>
                  <Grid item xs={12} md={12} sm={12}>
                    <Typography variant="subtitle1" className={classes.sutitle} gutterBottom>
                      {skuAtual?.sku}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={12} sm={12}>
                    <Typography variant="subtitle1" color="primary" className={classes.tagSobEncomenda} gutterBottom>
                      {skuAtual?.sob_encomenda ? 'Sob Encomenda' : null}
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Skeleton animation="wave" />
              )}
              {product && product.desconto_percentual > 0 && <div className={classes.tag}>Promoção</div>}
            </Grid>
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-around',
              }}
            >
              <Grid item xs={4} sm={5}>
                <Typography variant="body1" color="primary" className={classes.label} gutterBottom>
                  Unidade:
                </Typography>
                <Typography variant="button" gutterBottom>
                  {loading && <CircularProgress color="primary" />}
                  {!product && <Skeleton animation="wave" />}
                  {product && !loading && (
                    <>
                      {product.desconto_percentual > 0 && (
                        <div
                          style={{
                            position: 'relative',
                            display: 'inline-block',
                          }}
                        >
                          <div
                            style={{
                              height: 1,
                              width: '107%',
                              backgroundColor: '#000',
                              position: 'absolute',
                              bottom: 51,
                            }}
                          />
                          <Typography
                            variant="body1"
                            color="primary"
                            className={classes.label}
                            style={{
                              fontSize: '1.1rem',
                              textTransform: 'capitalize',
                              lineHeight: 0.5,
                            }}
                          >
                            De:
                          </Typography>
                          <span className={classes.sub} style={{ fontSize: '0.8rem' }}>
                            R$
                          </span>
                          <span className={classes.money} style={{ fontSize: '1.6rem' }}>
                            {valorDe ? valorDe[0] : ''}
                          </span>
                          <span className={classes.sob} style={{ fontSize: '0.8rem' }}>
                            ,{valorDe ? valorDe[1] : ''}
                          </span>
                          {/* <div className={classes.discount}>{'R$' + valorUnitario[0] + ',' + valorUnitario[1]}</div> */}
                          <Typography
                            variant="body1"
                            color="primary"
                            className={classes.label}
                            style={{
                              fontSize: '1.5rem',
                              textTransform: 'capitalize',
                            }}
                          >
                            Por:
                          </Typography>
                        </div>
                      )}
                      <div style={{ marginTop: -12 }}>
                        <span className={classes.sub}>R$</span>
                        <span className={classes.money}>{valorUnitario ? valorUnitario[0] : ''}</span>
                        <span className={classes.sob}>,{valorUnitario ? valorUnitario[1] : ''}</span>
                      </div>
                    </>
                  )}
                </Typography>
              </Grid>
              <div>
                <Divider orientation="vertical" className={classes.divider} />
              </div>
              <Grid item xs={6} sm={5}>
                <Typography variant="body1" color="primary" className={classes.label}>
                  Total:
                </Typography>
                <Typography variant="button" gutterBottom>
                  {loading && <CircularProgress color="primary" />}
                  {!product && <Skeleton animation="wave" />}
                  {product && !loading && (
                    <div>
                      <span className={`${classes.sub} ${classes.secondary}`}>R$</span>
                      <span className={`${classes.money} ${classes.secondary}`}>{valorTotal ? valorTotal[0] : ''}</span>
                      <span className={`${classes.sob} ${classes.secondary}`}>,{valorTotal ? valorTotal[1] : ''}</span>
                    </div>
                  )}
                </Typography>
                {/* <Typography variant="caption" color="primary" display="block" className={classes.subLabel} gutterBottom>
                  em até 12x
                </Typography> */}
              </Grid>
            </div>
            {!skuAtual?.sob_encomenda && (
              <Grid item xs={12} md={12} sm={12} style={{ paddingBottom: 0 }}>
                <Typography variant="body1" color="primary" className={classes.estoque} gutterBottom>
                  Estoque:{' '}
                  <span style={{ color: '#000', fontSize: '1.8rem' }}>
                    {skuAtual?.estoque_fornecedor ?? <Skeleton animation="wave" />}
                  </span>
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" color="primary" className={classes.label} gutterBottom>
                Quantidade:
              </Typography>
              <NumberButtonsInput
                minValue={product ? parseInt(product.quantidade_minima) : 1}
                maxValue={product && !skuAtual?.sob_encomenda ? parseInt(skuAtual?.estoque_fornecedor) : undefined}
                valueDefault={product ? parseInt(product.quantidade_padrao) : 500}
                onChange={debouncedHandleQtd}
                value={parseFloat(qtd)}
              />
              <Typography variant="caption" component="p" color="error" style={{ lineHeight: 1, marginTop: 8 }}>
                *Favor consultar estoque antes de finalizar a compra.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" color="primary" className={classes.label} gutterBottom>
                Gravação:
              </Typography>
              <CustomSelect value={gravacao} options={options} onChange={_handleGravacao} />
            </Grid>
            {variacoes &&
              variacoes.length > 1 &&
              atributos &&
              skuAtual &&
              Object.entries(atributos).map(([key, values], index) => {
                const selectedValue = skuAtual?.atributos.find(
                  (attr) => attr.atributo.toLowerCase() === key.toLowerCase()
                )?.valor

                return (
                  <Grid item xs={12} sm={6} key={index}>
                    <Typography variant="body1" color="primary" className={classes.label} gutterBottom>
                      {key.charAt(0).toUpperCase() + key.slice(1)}:
                    </Typography>
                    <CustomSelect
                      value={selectedValue || ''}
                      options={values.map((value) => ({ value, text: value }))}
                      onChange={(e) => handleAtributosChange(key, e.target.value)}
                    />
                  </Grid>
                )
              })}
            <Grid item xs={12} className={classes.gridCallToAction}>
              {/* {!loadingPage && (
                <>
                  {product?.tem_estoque ? (
                    <CallToAction
                      progress={loading}
                      text=" "
                      scheme="cart"
                      onClick={addToCart}
                      icon={<ShoppingCartOutlinedIcon style={{ fontSize: 42 }} />}
                    />
                  ) : (
                    <Typography variant="subtitle1" color="error" style={{ lineHeight: 1 }}>
                      Temporariamente fora de estoque.
                    </Typography>
                  )}
                </>
              )} */}
              <CallToAction
                progress={loading}
                text=" "
                scheme="cart"
                disabled={skuAtual?.estoque_fornecedor === 0}
                onClick={addToCart}
                icon={<ShoppingCartOutlinedIcon style={{ fontSize: 42 }} />}
              />
            </Grid>
          </Grid>
        </Grid>
        <Hidden xsUp>
          {/* <ListCheckbox itens={itensCheckbox} changeValue={debouncedHandleQtd} value={qtd} /> */}
        </Hidden>

        <Grid container spacing={3} direction="row" alignItems="flex-start" className={classes.marginTop}>
          <Grid item xs={12} md={7}>
            {product && <VitrineProdutos {...vitrineData} />}
          </Grid>

          <Grid item xs={12} md={5}>
            <Typography variant="h4" component="h3" className={classes.title} gutterBottom>
              Descrição
            </Typography>
            <Typography variant="subtitle1" className={classes.sutitle} gutterBottom>
              {product ? product.detalhe : <Skeleton animation="wave" />}
            </Typography>

            <Typography variant="h4" component="h3" className={`${classes.title} ${classes.marginTop}`} gutterBottom>
              Prazo de Entrega
            </Typography>
            <Typography variant="subtitle1" className={classes.sutitle} gutterBottom>
              10 dias úteis + frete à consultar.
            </Typography>
            {shop?.conf?.geral?.whatsapp && (
              <>
                <Button
                  variant="contained"
                  endIcon={<img src={WhatsAppIcon} alt="Icone de telefone" width={40} height={40} />}
                  fullWidth
                  className={`${classes.button} ${classes.marginTop}`}
                  target="_blank"
                  href={`https://api.whatsapp.com/send?phone=55${shop?.conf?.geral?.whatsapp}&text=Ol%C3%A1!%20Gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20produtos`}
                >
                  <Typography variant="button" className={classes.textButton}>
                    Faça sua cotação pelo
                  </Typography>
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Container>
      {/* {shop.link === 'drika.com.br' && <NewsletterContainer />} */}
      <Container style={{ marginTop: 24 }}>
        <Categorys itens={itens} />
      </Container>
      <AlertDialog
        open={openDialog}
        button1={{ text: 'Continuar comprando', onClick: () => setOpenDialog(false) }}
        button2={{ text: 'Ir para o carrinho', href: '/carrinho' }}
        title="Produto adicionado ao carrinho"
        text="Seu produto foi adicionado ao seu carrinho, o que gostaria da fazer agora?"
        onClose={() => setOpenDialog(false)}
      />
      <Footer />
    </Fragment>
  )
}

export default Product
